/**
 * Platform Billing Types
 * ============================================
 * Organization Owners paying the Platform
 * This is B2B billing for SaaS subscription management.
 *
 */
// ============================================
// ENUMS
// ============================================
export var PlatformPlanTier;
(function (PlatformPlanTier) {
    PlatformPlanTier[PlatformPlanTier["FREE"] = 0] = "FREE";
    PlatformPlanTier[PlatformPlanTier["STARTER"] = 1] = "STARTER";
    PlatformPlanTier[PlatformPlanTier["PROFESSIONAL"] = 2] = "PROFESSIONAL";
    PlatformPlanTier[PlatformPlanTier["ENTERPRISE"] = 3] = "ENTERPRISE";
})(PlatformPlanTier || (PlatformPlanTier = {}));
export var PlatformPlanSlug;
(function (PlatformPlanSlug) {
    PlatformPlanSlug["STARTER"] = "starter";
    PlatformPlanSlug["PROFESSIONAL"] = "professional";
    PlatformPlanSlug["ENTERPRISE"] = "enterprise";
    PlatformPlanSlug["PARTNER_BASIC"] = "partner_basic";
})(PlatformPlanSlug || (PlatformPlanSlug = {}));
export var PlatformFeatureCode;
(function (PlatformFeatureCode) {
    PlatformFeatureCode["ANALYTICS_DASHBOARD"] = "analytics_dashboard";
    PlatformFeatureCode["CUSTOM_BRANDING"] = "custom_branding";
    PlatformFeatureCode["PRIORITY_SUPPORT"] = "priority_support";
    // Quantity-limited features
    PlatformFeatureCode["MAX_ESTABLISHMENTS"] = "max_establishments";
    PlatformFeatureCode["MAX_STAFF_MEMBERS"] = "max_staff_members";
    PlatformFeatureCode["MAX_ANIMALS"] = "max_animals";
    // LLM Features
    PlatformFeatureCode["LLM_ACCESS"] = "llm_access";
    PlatformFeatureCode["LLM_BUDGET_CENTS_PER_MONTH"] = "llm_budget_cents_per_month";
})(PlatformFeatureCode || (PlatformFeatureCode = {}));
// Using uppercase values to match the DB enums
// Maps to Stripe subscription statuses: incomplete, incomplete_expired, trialing, active, past_due, canceled, unpaid, paused
export var PlatformSubscriptionStatus;
(function (PlatformSubscriptionStatus) {
    PlatformSubscriptionStatus["INCOMPLETE"] = "INCOMPLETE";
    PlatformSubscriptionStatus["INCOMPLETE_EXPIRED"] = "INCOMPLETE_EXPIRED";
    PlatformSubscriptionStatus["TRIALING"] = "TRIALING";
    PlatformSubscriptionStatus["ACTIVE"] = "ACTIVE";
    PlatformSubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    PlatformSubscriptionStatus["CANCELED"] = "CANCELED";
    PlatformSubscriptionStatus["UNPAID"] = "UNPAID";
    PlatformSubscriptionStatus["PAUSED"] = "PAUSED";
})(PlatformSubscriptionStatus || (PlatformSubscriptionStatus = {}));
export var PlatformBillingCycle;
(function (PlatformBillingCycle) {
    PlatformBillingCycle["MONTHLY"] = "MONTHLY";
    PlatformBillingCycle["YEARLY"] = "YEARLY";
})(PlatformBillingCycle || (PlatformBillingCycle = {}));
export var PlatformLimitType;
(function (PlatformLimitType) {
    PlatformLimitType["BOOLEAN"] = "BOOLEAN";
    PlatformLimitType["QUANTITY"] = "QUANTITY";
    PlatformLimitType["UNLIMITED"] = "UNLIMITED";
})(PlatformLimitType || (PlatformLimitType = {}));
//# sourceMappingURL=PlatformPlan.js.map